import {
  ITransaction,
  SlTitledListComponent,
} from '@varo/graphql-schema-types';
import { router } from 'expo-router';
import { TransactionGroup } from 'shared/components/TransactionSectionList/TransactionSectionList';
import { amountStyles } from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import { formatDate } from 'shared/utils/string/date';
import { toTitleCase } from 'shared/utils/string/string.helpers';

export type PayOverTimeTransactionDetailsParams = {
  amount: string;
  description: string;
  date: string;
  status: string;
};

const mapToTransactionDetailsParams = (
  transaction: ITransaction,
): PayOverTimeTransactionDetailsParams => ({
  amount:
    transaction.value.formattedWithPlusPrefix ?? transaction.value.formatted,
  description: transaction.description,
  date: formatDate(transaction.createdAt, 'MMM d, yyyy'),
  status: toTitleCase(transaction.status.replace(/_/g, ' ')),
});

const mapToTransactionSectionList = (
  transaction: SlTitledListComponent,
  disablePress = false,
): TransactionGroup => {
  return {
    title: transaction.title?.copy ?? '',
    transactions: transaction.children.map((child) => {
      const rawAmount = child.primaryDetail?.copy ?? '';
      const primaryText = child.primaryText?.copy ?? '';
      const date = child.secondaryText?.copy ?? '';
      const transactionDetailsParams = child.onClick?.transaction
        ? mapToTransactionDetailsParams(child.onClick.transaction)
        : null;

      return {
        secondaryDetail: child.secondaryDetail?.copy ?? '',
        titleText: primaryText,
        amountText: rawAmount,
        secondaryText: date,
        balanceText: child.secondaryDetail?.copy ?? '',
        isPending: false,
        amountStyle: rawAmount.startsWith('+')
          ? amountStyles.POSITIVE
          : amountStyles.NEUTRAL,
        onPress:
          disablePress || !transactionDetailsParams
            ? undefined
            : () => {
                router.navigate({
                  pathname: '/pay-over-time/transaction-details',
                  params: transactionDetailsParams,
                });
              },
      };
    }),
  };
};

export default mapToTransactionSectionList;
